import styled from '@emotion/styled';
import COLORS, { COLORS_TEXT, COLORS_BACKGROUND } from '../../../../styles/emotion/colors';
import FONT from '../../../../styles/emotion/fonts';

export const StyledDayPicker = styled.div`
  & > .DayPicker {
    color: ${COLORS_TEXT.PRIMARY};
    ${FONT.textSizeRegular(FONT.FONT_SIZE_SMALL)};
    font-weight: ${FONT.FONT_WEIGHT_REGULAR};
    background: ${COLORS_BACKGROUND.WHITE};
    border: 1px solid ${COLORS.ALTO};
    border-radius: 3px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    min-width: 279px;
  }

  .DayPicker-NavButton {
    &--prev {
      top: 1.2em;
      right: 50px;
    }

    &--next {
      top: 1.2em;
      right: 20px;
    }
  }

  .DayPicker-Weekday {
    padding-left: 0;
    padding-right: 0;
    color: ${COLORS.SCREAMING_GREY};
    font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  }

  .DayPicker-Day {
    width: 35px;
    height: 35px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    outline: none;

    &:hover {
      background-color: ${COLORS.GEYSER} !important;
    }

    &--today {
      color: ${COLORS_TEXT.PRIMARY};
      font-weight: ${FONT.FONT_WEIGHT_REGULAR}r;
    }

    &--outside {
      color: ${COLORS.ALTO};
    }

    &--selected,
    &--selected:hover {
      color: ${COLORS_BACKGROUND.WHITE}; !important;
      background-color: ${COLORS_BACKGROUND.NAVY} !important;
    }
  }
`;

export const PickerContainer = styled.div`
  position: relative;

  ${StyledDayPicker} {
    position: absolute;
    margin-top: 8px;
    z-index: 5;
  }
`;
